export default __webpack_public_path__ + "static/media/blue-banner-img.eec16b99.png";